/**
 * THE brand (rebrand to Rawaaj Mall, 29 Oct 2026). Every user-visible name,
 * logo and site URL in the CRA app reads from here -- a future rename or a
 * new logo is a change to this file (and backend/app/core/brand.py +
 * storefront/lib/brand.ts) only. Locale strings use {{brandName}}, {{brandCoins}}
 * and {{brandAssistant}}, filled in by i18n's t() from brandVars().
 *
 * Not renamed on purpose: code identifiers, localStorage keys ("zaynic-*"),
 * env var names, DB names, the repo and the Vercel project.
 */
import logo from 'images/brand/rawaaj-logo.svg';
import monogram from 'images/brand/rawaaj-monogram.svg';

export const BRAND = {
  name: 'Rawaaj Mall',
  nameUr: 'رواج مال',
  wordmark: 'RAWAAJ MALL',
  short: 'RawaajMall', // where spaces aren't allowed
  slug: 'rawaajmall',
  coins: 'Rawaaj Coins',
  coinsUr: 'رواج کوائنز',
  assistant: 'Rawaaj Assistant',
  assistantUr: 'رواج اسسٹنٹ',
  social: '@rawaajmall',
  // Swap these two files to change the logo everywhere.
  logo,
  monogram,
};

/** The site's own public URL: REACT_APP_SITE_URL when set (e.g. https://rawaajmall.pk), else this origin. */
export function siteUrl() {
  const fromEnv = process.env.REACT_APP_SITE_URL;
  if (fromEnv) return fromEnv.replace(/\/+$/, '');
  return typeof window !== 'undefined' ? window.location.origin : '';
}

/** Host shown on printed documents ("rawaajmall.pk"). */
export function siteHost() {
  try {
    return new URL(siteUrl()).host;
  } catch (e) {
    return BRAND.slug;
  }
}

/** Default {{brandName}}/{{brandCoins}}/{{brandAssistant}} values for a language. */
/**
 * Customer support line (WhatsApp + calls). Change it here only; locale strings
 * use {{supportPhone}}. Vendors' own numbers are never these.
 */
export const SUPPORT_PHONE_E164 = '+923153611165';
export const SUPPORT_PHONE_DISPLAY = '+92 315 3611165';
export const SUPPORT_PHONE_LOCAL = '03153611165';
export const SUPPORT_PHONE_TEL = `tel:${SUPPORT_PHONE_E164}`;
export const SUPPORT_PHONE_WA = 'https://wa.me/923153611165';

// No platform wallet number in code: house JazzCash = the house store's saved payment settings (hooks/useHouseWallet).

export function brandVars(language) {
  const ur = language === 'ur';
  return {
    supportPhone: SUPPORT_PHONE_DISPLAY,
    brandName: ur ? BRAND.nameUr : BRAND.name,
    brandCoins: ur ? BRAND.coinsUr : BRAND.coins,
    brandAssistant: ur ? BRAND.assistantUr : BRAND.assistant,
  };
}

/** The logo every header/footer/invoice uses (swap the SVG file to change it). */
export const BRAND_LOGO = BRAND.logo;

/** Old house-store handle -> new one (backend/app/core/brand.py has the same map). */
export const LEGACY_STORE_HANDLES = { zaynic: 'rawaajmall' };
